import React from "react";
import { Link } from "react-router-dom";

/**
 * Navigasyon primitifi. React Router Link üzerinden gerçek <a href="#/..."> render eder,
 * böylece tarayıcının "Yeni sekmede aç" / Ctrl+tık / orta-tık davranışları çalışır.
 * Stil nötrdür (color: inherit, text-decoration: none); sarılan öğenin görünümünü bozmaz.
 * display sınıfı tüketici className'inden gelir (örn. "absolute inset-0", "flex flex-col").
 */
const AppLink = React.forwardRef(function AppLink(
  { to, state, className = "", children, ...rest },
  ref
) {
  return (
    <Link
      ref={ref}
      to={to}
      state={state}
      className={`text-inherit no-underline ${className}`}
      {...rest}
    >
      {children}
    </Link>
  );
});

export default AppLink;
